module.exports = __webpack_public_path__ + "static/team-31-4705523dc6d408012844525ee3ecc8b4.jpg";